import React, { useState } from "react";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMMarkdownContainer from "src/components/UI/atoms/ATMMarkdownContainer/ATMMarkdownContainer";
import ATMSelect from "src/components/UI/atoms/formFields/ATMSelect/ATMSelect";
import ATMTextArea from "src/components/UI/atoms/formFields/ATMTextArea/ATMTextArea";
import AccordianFormLayout from "src/components/layouts/AccordianFormLayout/AccordianFormLayout";
import AssigmentLayout from "src/screens/Student/Components/StudentAssignment/AssigmentLayout/AssigmentLayout";
import { useAddQuestionRemarkMutation } from "src/services/QuestionBankServices";
import { showToast } from "src/utils/showToaster";
import AssignmentUnCompleteStudents from "./AssignmentUnCompleteStudents";

type Props = {
  title: string;
  assignment: any;
  questionLabel: any;
  questionId: string;
  studentAvailable: any;
  batchId: string;
  totalStudent: string;
  doneByStudents: string;
  assignmentId: string;
};

const ViewSolutionScreen = ({
  title,
  assignment,
  questionLabel,
  questionId,
  studentAvailable,
  batchId,
  doneByStudents,
  totalStudent,
  assignmentId,
}: Props) => {
  const [selectedStudent, setSelectedStudent] = useState<any>(null);
  const [remarkValue, setRemarkValue] = useState<any>("");
  const [isOpenStudentDialog, setIsOpenStudentDialog] = useState(false);

  //Remak mutation
  const [addRemark, addRemarkInfo] = useAddQuestionRemarkMutation();

  //get Student Options
  const getStudents = (rawData: any[]) => {
    return rawData?.map((data) => ({
      label: data?.studentLabel,
      value: data?.studentId,
      solutions: data?.solution,
      remark: data?.remark,
    }));
  };

  //Add Remark Submit
  const handleSubmit = () => {
    addRemark({
      body: {
        remark: remarkValue,
      },
      questionId: questionId,
      studentId: selectedStudent?.value,
      batchId: batchId,
    }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
        } else {
          showToast("error", res?.data?.message);
        }
      }
    });
  };

  return (
    <>
      <AccordianFormLayout
        SubHeadingClasses="bg-red-400 px-4 py-1 text-white font-medium rounded"
        SubHeadingOnclick={() => {
          setIsOpenStudentDialog(true);
        }}
        SubHeading={
          <span>
            {doneByStudents}/{totalStudent}
          </span>
        }
        formHeading={
          <div className="text-base cursor-pointer line-clamp-2 text-primary-dark">
            <ATMMarkdownContainer markdown={title} />
          </div>
        }
      >
        <div className="" >
          <div className="flex justify-end">
            {/* Select Student */}
            <div className="my-3 mr-5">
              <ATMSelect
                disabled={!studentAvailable?.[0]}
                name=""
                value={selectedStudent}
                onChange={(newValue) => setSelectedStudent(newValue)}
                label="Students"
                options={getStudents(assignment)}
              />
            </div>
          </div>

          <div className="grid h-full grid-cols-12">
            {/* Question describtion */}

            <div
              className={`${
                selectedStudent ? "col-span-3" : "col-span-full"
              }  border-r-2 text-[20px] font-medium p-2 max-h-[650px] overflow-auto`}
            >
              <ATMMarkdownContainer markdown={questionLabel} />
            </div>
            {selectedStudent && (
              <div className="h-full col-span-9 p-2">
                <AssigmentLayout data={selectedStudent?.solutions} />
                {/* Add Remark Input */}
                <ATMTextArea
                  label="Remark"
                  required
                  value={remarkValue || selectedStudent?.remark}
                  onChange={(newValue) => {
                    setRemarkValue(newValue);
                  }}
                />
                {/* Button */}
                <div className="flex justify-end">
                  <ATMLoadingButton
                    className="w-[80px]"
                    onClick={handleSubmit}
                    isLoading={addRemarkInfo?.isLoading}
                  >
                    {" "}
                    Save
                  </ATMLoadingButton>
                </div>
              </div>
            )}
          </div>
        </div>
      </AccordianFormLayout>
      {isOpenStudentDialog && (
        <AssignmentUnCompleteStudents
          onClose={() => setIsOpenStudentDialog(false)}
          assignmentId={assignmentId}
        />
      )}
    </>
  );
};

export default ViewSolutionScreen;
